export const ORDERS_SEARCH_MIN_LENGTH = 3
